//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PaymentSourceType } from './Enums';

export class StripePaymentSourceSetupUpdateItem extends ItemBase {
    PaymentSourceJWT: string | null = null;
    PaymentSourceType: PaymentSourceType = PaymentSourceType.BankAccount;
    Amount: number = 0;
    OneTime: boolean = false;

    constructor(initializer?: Partial<StripePaymentSourceSetupUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StripePaymentSourceSetupUpdateItem";
}
